import { apiGet, getApiUrl } from "Infrastructure/Api/Api";
import { useQuery } from "@tanstack/react-query";

export interface ProtocolRecord {
	id: number;
	orderId: number;
	partnerId: number;
	type: "start" | "handover";
	status: "draft" | "sent" | "accepted" | "declined";
	partnerAcceptedAt: string | null;
	customerAcceptedAt: string | null;
	customerName: string | null;
	customerComment: string | null;
	sentAt: string | null;
	templateKey: string | null;
	priceAdjustmentNotes: string | null;
	finalPrice: number | null;
	customerDecision: {
		checklist?: Record<string, boolean>;
		invoiceRequested?: boolean;
		decidedAt?: string;
		acceptedAt?: string;
		autoApproved?: boolean;
	} | null;
	dateCreated: string;
}

export const ORDER_PROTOCOLS_KEY = "ORDER_PROTOCOLS";

export const useOrderProtocolsQuery = (orderId: number | undefined) =>
	useQuery({
		queryKey: [ORDER_PROTOCOLS_KEY, orderId],
		queryFn: async (): Promise<ProtocolRecord[]> => {
			const response = await apiGet(
				`${getApiUrl()}/orders/${orderId}/protocols`,
				new Headers(),
				{},
			);
			if (response.status >= 400) throw new Error("Failed to fetch protocols");
			return response.data as ProtocolRecord[];
		},
		enabled: !!orderId,
		refetchInterval: 30_000,
	});
